import React from 'react';
import Icon from '../../../components/AppIcon';


const PermitTypeCard = ({ permit, onSelect, isSelected }) => {
  return (
    <div 
      className={`relative overflow-hidden rounded-lg border-2 transition-all duration-300 cursor-pointer ${
        isSelected 
          ? 'border-[var(--color-accent)] bg-[var(--color-card)] shadow-conservation-lg' 
          : 'border-[var(--color-border)] bg-[var(--color-card)] hover:border-[var(--color-primary)] hover:shadow-conservation'
      }`}
      onClick={() => onSelect(permit?.id)}
    >
      {permit?.popular && (
        <div className="absolute top-0 right-0 bg-[var(--color-accent)] text-[var(--color-accent-foreground)] px-3 py-1 text-xs font-medium">
          POPULAR
        </div>
      )}
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className={`p-3 rounded-lg ${isSelected ? 'bg-[var(--color-accent)]' : 'bg-[var(--color-primary)]'}`}>
              <Icon name={permit?.icon} size={24} color="var(--color-primary-foreground)" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-[var(--color-foreground)]">{permit?.name}</h3>
              <p className="text-sm text-[var(--color-muted-foreground)]">{permit?.duration}</p>
            </div>
          </div>
          {isSelected && (
            <Icon name="CheckCircle2" size={24} color="var(--color-accent)" />
          )}
        </div>

        <p className="text-sm text-[var(--color-muted-foreground)] mb-4 leading-relaxed">
          {permit?.description}
        </p>

        <div className="space-y-2 mb-4">
          {permit?.features?.map((feature, index) => (
            <div key={index} className="flex items-center gap-2">
              <Icon name="Check" size={16} color="var(--color-success)" />
              <span className="text-sm text-[var(--color-foreground)]">{feature}</span>
            </div>
          ))}
        </div>

        <div className="flex items-baseline justify-between pt-4 border-t border-[var(--color-border)]">
          <div>
            <span className="text-2xl font-bold text-[var(--color-accent)]">
              {permit?.price?.php}
            </span>
            <span className="text-sm text-[var(--color-muted-foreground)] ml-2">PHP</span>
          </div>
          <div className="text-right">
            <span className="text-lg font-semibold text-[var(--color-foreground)]">
              {permit?.price?.usd}
            </span>
            <span className="text-sm text-[var(--color-muted-foreground)] ml-1">USD</span>
          </div>
        </div>

        {permit?.quota && (
          <div className="mt-3 flex items-center gap-2 text-xs text-[var(--color-warning)]">
            <Icon name="AlertCircle" size={14} />
            <span>Only {permit?.quota} permits available today</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PermitTypeCard;